import { callAgroApi } from '@services/agroapi';
export const withSeasons = self => ({
  actions: {
    createSeason(season: {
      name: string;
      start_datetime: string;
      end_datetime: string;
      country: string | null;
      region: string | null;
      crop_name: string | null;
      pending_plantation: boolean;
    }) {
      return callAgroApi(`/organizations/${self.id}/seasons`, 'POST', season);
    },
    updateSeason(season) {
      return callAgroApi(`/organizations/${self.id}/seasons/${season.id}`, 'PATCH', season);
    },
    deleteSeason(seasonId: string) {
      return callAgroApi(`/organizations/${self.id}/seasons/${seasonId}`, 'DELETE');
    }
  }
});